import { Box, Flex, Text } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import Image from "next/image";
import Link from "next/link";
import { useQuery } from "react-query";

export const Ingredient = ({ content, size }) => {
  const supabase = createClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_KEY
  );
  const getIngredient = async (): Promise<any> => {
    try {
      //@ts-ignore
      let { data } = await supabase
        .from("ingredients")
        .select("*, inci(text), title(text), description(text)")
        .eq("id", `${content.id}`);
      return data[0];
    } catch (err) {
      console.log(err);
    }
  };
  const { data: ingredient } = useQuery(
    ["getIngredient", content],
    () => getIngredient(),
    { enabled: Boolean(content) }
  );
  if (ingredient)
    return (
      <Link href={`/ingredients/${ingredient.slug}`}>
        <Box
          border="1px solid grey200"
          minWidth={"200px"}
          borderRadius="md"
          p={size === 3 ? "15px" : ["12px", "25px"]}
          textAlign="left"
          cursor="pointer"
          height={[
            content.isSmallCard ? "95px" : "216px",
            size === 3 ? "228px" : "323px",
          ]}
        >
          <Flex justifyContent={"space-between"}>
            <Text
              fontSize="12px"
              color="#767473"
              fontFamily="DINPro"
              lineHeight="16px"
            >
              INGREDIENT
            </Text>
            <Image
              width={22}
              height={22}
              src={`https://static.ewg.org/skindeep/img/draw_score/score_image${ingredient.ewg}_${ingredient.ewg}_1_.png`}
            />
          </Flex>
          <Text
            fontFamily="DINPro"
            fontWeight={700}
            fontSize={["16px", "18px"]}
          >
            {ingredient.title?.text}
          </Text>
          <Text
            mt="8px"
            fontStyle="italic"
            color="#767473"
            fontSize={["14px", "16px"]}
          >
            {ingredient.inci?.text}
          </Text>
          <Text
            display={["none", "block"]}
            color="#767473"
            mt="15px"
            lineHeight={"25px"}
            overflow="hidden"
          >
            {ingredient.description?.text
              .replace(/<\/?[^>]+(>|$)/g, "")
              .slice(0, size === 3 ? 100 : 350) + "..."}
          </Text>
          <Text
            display={[content.isSmallCard ? "none" : "block", "none"]}
            color="#767473"
            mt="15px"
            lineHeight={"25px"}
            overflow="hidden"
          >
            {ingredient.description?.text
              .replace(/<\/?[^>]+(>|$)/g, "")
              .slice(0, 160) + "..."}
          </Text>
        </Box>
      </Link>
    );
  return null;
};
